import { AppService } from '@aperza/util';
import React from 'react';
import { useResponsiveContext } from '../util/ResponsiveContext';
export function FooterLogo() {
    const { isMobile, isDesktop, isLargeDesktop } = useResponsiveContext();
    const logoAlt = 'アペルザ（Apérza）';
    const logoSrc = `${AppService.staticServerHost()}/common/images/aperza2022/red/logo_yoko.svg`;
    // mobile
    if (isMobile) {
        return React.createElement("img", { alt: logoAlt, src: logoSrc, width: 157, height: 35 });
    }
    // mid Desktop
    if (isDesktop && !isLargeDesktop) {
        return React.createElement("img", { alt: logoAlt, src: logoSrc, width: 174, height: 39 });
    }
    // large Desktop
    return React.createElement("img", { alt: logoAlt, src: logoSrc, width: 192, height: 43 });
}
